var map = {
	"./Droper.svg": 258,
	"./edit.svg": 211,
	"./icon-0.svg": 755,
	"./icon-1.svg": 404,
	"./icon-2.svg": 756,
	"./icon-3.svg": 757,
	"./icon-4.svg": 758,
	"./sort-active.svg": 137,
	"./sort.svg": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;